module.exports = __webpack_public_path__ + "static/media/javascript.9a073369.svg";